export default {
  gst:[],
  currentGST:{name:"",value:0}
}